
import '../styles/about.css'

const About = () => {

    return ( 
    <div className="about-cont">
        <div className="header-cont">
            <div>
                <h1>
                    <span>ABOUT</span>
                    <span>ACHARYA</span>
                    <span>INTL.</span>
                </h1>
            </div>
            <div>
                <p>Welcome to <span>Acharya International School</span>, a premier institution dedicated to nurturing young minds and shaping
                the leaders of tomorrow. <span>Founded in 2005,</span> our school has been a beacon of quality education, holistic
                development, and academic excellence.</p>
                
                <p>At <span>Acharya International School</span>, we believe that every child is unique and has the potential to achieve great
                heights. With this philosophy in mind, we offer a dynamic learning environment that <span>encourages creativity, critical
                thinking, and personal growth.</span></p>

                <p> Our experienced faculty members are passionate about teaching and are committed to providing students with a
                comprehensive <span>education that goes beyond textbooks.</span> We emphasize experiential learning, where students
                actively participate in various activities, projects, and field trips to gain <span>practical knowledge and skills.</span></p>
                
                <p>We understand the importance of a well-rounded education, which is why we offer a wide range of <span>co-curricular
                activities, sports, and clubs</span> to cater to the diverse interests of our students. Whether it's <span>music, art, dance, or
                sports,</span> there's something for everyone at Acharya International School.</p>
                
                <p>At <span>Acharya International School,</span> we strive to create a warm and welcoming environment where students feel safe,
                supported, and inspired to learn. We foster a strong sense of <span>community</span> and <span>encourage collaboration, respect,
                and empathy</span> among our students.</p>
                
                <p>Join us at Acharya International School, where learning is a <span>lifelong journey</span> filled with <span>endless possibilities.</span></p>
            </div>
        </div>
        <div className="founders-message">
            <div className="founder-image">       
            </div>
            <div>
                <h1>
                    <span style={{color:"#F7D246"}}>FOUNDER’S</span>
                    <span>MESSAGE</span>
                </h1>

                <p>Dear Parents, Students, and Members of the Acharya International ICSE School
                Community,</p>

                <p>It gives me immense pleasure to welcome you to Acharya International ICSE
                School, a place where we embark on a journey of learning, growth, and discovery
                together.</p>

                <p>As the founder of this esteemed institution, I am deeply committed to providing a
                nurturing environment where students can thrive academically, socially, and
                emotionally. Our vision for Acharya International ICSE School is rooted in the belief
                that education is the cornerstone of progress and prosperity, and every child
                deserves access to quality education that equips them with the knowledge, skills,
                and values to succeed in a rapidly changing world.</p>

                <p>At Acharya International ICSE School, we strive to create a learning community
                where excellence is not just a goal, but a way of life. Our dedicated team of
                educators is passionate about igniting the spark of curiosity in our students,
                fostering critical thinking, creativity, and a love for lifelong learning.</p>

                <p>Beyond academics, we place a strong emphasis on character development,
                leadership skills, and social responsibility. We believe in nurturing well-rounded
                individuals who not only excel academically but also demonstrate integrity,
                empathy, and a commitment to making a positive difference in the world.</p>

                <p>As we embark on this journey together, I invite you to join us in shaping the future
                of our students and our community. Together, let us inspire, empower, and
                support each other as we strive for excellence and work towards building a
                brighter tomorrow.</p>
                
                <p>Thank you for choosing Acharya International ICSE School. I look forward to seeing
                our students grow and thrive as they embark on their educational journey with us.
                </p>
            </div>
        </div>
        <div className="image-displayer"></div>
        <div className="our-moto">
            <div className="message">
                <div className="header-msg">
                </div>
                <div className="para-msg">
                    <p>"<span>Empowering students to excel in a global society </span>, Acharya International ICSE School cultivates a community of
                    learners committed to integrity, innovation, and collaboration. Our motto, <span>'Striving for Excellence, Nurturing
                    Character, and Inspiring Leadership, </span> ' encapsulates our dedication to providing holistic education that fosters
                    academic achievement, moral values, and leadership qualities. Through a dynamic curriculum, <span>state-of-the-art
                    facilities</span>, and a <span>supportive environment</span>, we empower students to reach their full potential and become
                    compassionate, responsible citizens of the world. At Acharya International ICSE School, we believe in nurturing not
                    only scholars but also <span>well-rounded individuals</span> equipped to thrive in an <span>ever-changing world</span>."</p>
                </div>
            </div>
            <div className="moto-images">
                <div id="moto1"></div>
                <div id="moto2"></div>
            </div>
        </div>
        <div className="our-message">
            <div className="mission">
                <div className="mission-image"></div>
                <div className="para-msg">
                    <p>"Our mission at <span>Acharya International School</span> is to provide a nurturing and inclusive learning
                    environment where students are inspired to discover their <span>passions, achieve academic excellence,</span> and
                    <span>develop essential life skills</span>. We are committed to fostering a culture of curiosity, critical thinking, and
                    creativity, preparing our students to thrive in an increasingly interconnected and diverse world. Through
                    <span> innovative teaching methodologies, personalized support</span>, and a focus on <span>holistic development</span>, we
                    empower our students to become compassionate, responsible <span>global citizens</span> who positively contribute to
                    society. At Acharya International ICSE School, we are dedicated to shaping future leaders who are equipped
                    with the <span>knowledge, values</span>, and <span>resilience</span> to navigate the challenges of the 21st century."</p>
                </div>
            </div>
            <div className="vision">
                <div className="vission-image"></div>
                <div className="para-msg">
                    <p>"Our vision at <span>Acharya International School</span> is to be a beacon of educational excellence, recognized
                    globally for nurturing students who embody <span>integrity, innovation, and leadership</span> . We aspire to create a
                    vibrant learning community where every individual is empowered to realize their full potential and contribute
                    positively to society. Through a dynamic and holistic approach to education, we aim to cultivate <span>inquisitive
                    minds, compassionate hearts</span>, and <span>responsible global citizens</span>. Our commitment to innovation,
                    collaboration, and continuous improvement drives us to create an inspiring and inclusive environment that
                    fosters lifelong learning and success. At Acharya International ICSE School, we envision a future where our
                    students lead with <span>purpose, integrity</span>, and a <span>commitment</span> to making a difference in the world."</p>
                </div>
            </div>
        </div>
    </div> );
}
 
export default About;